import { Button } from '@delmonicos/shared-design-system-react/src/components/button/button';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { TextArea } from '@delmonicos/shared-design-system-react/src/components/text-area/text-area.component';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { useCpmsBoAddMessageMutation } from '@service/cpms-bo-ticket.service';

import * as css from '../ticket-details/ticket-details.module.scss';

interface AddMessageComponentProps {
  id: string;
}

export const AddMessageComponent = ({
  id,
}: AddMessageComponentProps): React.JSX.Element => {
  const { t } = useTranslation();
  const [createMessage] = useCpmsBoAddMessageMutation();

  const { reset, handleSubmit, register } = useForm<{ message: string }>();

  const handleAddMessage = ({ message }: { message: string }) => {
    createMessage({ id, content: message })
      .unwrap()
      .then(() => {
        toast.success(t('$.ticket-details.message-create.success'));
        reset();
      })
      .catch(() => {
        toast.error(t('$.ticket-details.message-create.error'));
      });
  };

  return (
    <form onSubmit={handleSubmit(handleAddMessage)} className={css.newMessage}>
      <Stack direction="column" gap={GapEnum.S}>
        <TextArea
          {...register('message')}
          placeholder={t('$.ticket-details.message-create.placeholder')}
        />
        <Button type="submit">
          {t('$.ticket-details.message-create.save')}
        </Button>
      </Stack>
    </form>
  );
};
